import React from 'react';
import Layout from '../../components/Shared/Layout';
import Gamerize from '../../components/Portfolio/gamerize';
import '../../assets/css/gamerize.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class GamerizePage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/gamerize',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <Gamerize />
      </Layout>
    );
  }
}

export default GamerizePage;
